import store from "@/store";
import router from "@/router";
import request from "@/libs/request/axios";
import localStorage from "@/libs/localStorage";
import { forEach, isDev } from "@/libs/utils";
import ElementUI from "element-ui";

const LOADINGCFG = {
  lock: true,
  text: "LOADING",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.5)"
};
let Loading = "";

/**
 * control each route's authority
 * @param {Array} router router
 * @param {boolean} isChild if router's role is child
 * @return {Array} router
 */
export const controlRouteAuth = (router, isChild) => {
  let res = [];
  forEach(router, item => {
    let obj = { ...item };
    if (isChild)
      obj.meta ? (obj.meta["auth"] = true) : (obj.meta = { auth: true });
    if (item.meta && item.meta.auth && hasChild(item))
      obj.children = controlRouteAuth(item.children, true);
    res.push(obj);
  });

  return res;
};

/**
 * if current item has child
 * @param {*} item parent
 * @return {boolean}
 */
export const hasChild = item => {
  return item.children && item.children.length !== 0;
};

/**
 * go to login page
 */
export const gotoIndex = () => {
  router.push({ name: "index" });
};

/**
 * logout
 */
export const doLogout = () => {
  Loading = ElementUI.Loading.service(LOADINGCFG);
  request
    .doLogout()
    .then(() => {
      Loading.close();
      localStorage.clear();
      store.commit("clearLocalStorage");
      router.push({ name: "home" });
      ElementUI.Message.success("注销成功");
    })
    .catch(() => {
      Loading.close();
      ElementUI.Message.error("注销失败");
    });
};

/**
 * login
 */
export const doLogin = (param, cb) => {
  request
    .account_login(param)
    .then(res => {
      const { code = -1, msg = "" } = res;

      if (code !== 0) {
        this.error = msg;
        return;
      }

      const { userName, userToken, registerMode } = res;
      // this.error = "";

      const userinfo = {
        userName,
        registerMode
      };
      localStorage.set("token", userToken);
      localStorage.set("userinfo", userinfo);
      store.commit("setToken", userToken);
      store.commit("setUsername", userName);
      store.commit("setRegisterMode", registerMode);

      gotoIndex();

      cb && typeof cb === "function" && cb(res);
      ElementUI.Message.success("登录成功");
    })
    .catch(() => {
      ElementUI.Message.error("登录失败");
    });
};

/**
 * 检验token是否过期
 */
export const checkToken = () => {
  return new Promise(resolve => {
    // 是否登录
    if (!store.getters.getToken) {
      ElementUI.Message.warning("请先登录");
      resolve(false);
      return;
    }

    request
      .account_token()
      .then(res => {
        const { code = -1 } = res;
        if (code === 0) {
          resolve(true);
        } else if (code === 401) {
          ElementUI.Message.warning("账号未授权");
          resolve(false);
        }
      })
      .catch(() => {
        resolve(false);
        ElementUI.Message.error("验证失败");
      });
  });
};

/**
 * 获取外部系统的token
 */
export const getOuterToken = () => {
  return new Promise(resolve => {
    request.inquiry_accountAuth().then(res => {
      const { code, msg = "", data = {} } = res;

      if (Number(code) !== 10000) {
        ElementUI.Message.error(msg);
        resolve("");
      }

      resolve(data["userToken"] || "");
    });
  });
};

export const uploadTransferBaseParam = (params) => {
  return new Promise(async resolve => {
    const token = await getOuterToken();
    const user = store.getters.getUsername;

    if (!token) {
      resolve("");
      return;
    }

    let url = window.global[isDev() ? "devSystem" : "prodSystem"];
    url += `?token=${token}&user=${user}`;
    params && (url += `&${params}`);

    resolve(url);
  });
};
